<!--
  logo 组件 (可随意上传) 默认 logo_common
  顶部logo名 logo_common
  底部logo名 footer_logo
-->
<template>
  <span v-if="!logoError && EnterpriseId">
      <img :src="logoUrl"
           @error="()=>{ logoError=true; }"
           alt=""
      />
  </span>
  <span v-else>
      <img src="@/assets/images/logo.png" alt=""/>
  </span>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      logoUrl: '',
      logoError: false
    };
  },
  props: {
    name: {
      type: String,
      default: () => {
        return 'common';
      }
    },
    follow_name: {
      type: String,
      default: () => {
        return 'logo'
      }
    }
  },
  watch: {
    EnterpriseId: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.logoUrl = `${location.origin}/infoplus/file/enterprise/${val}/icon/${this.follow_name}_${this.name}.png`;
        }
      }
    }
  },
  computed: {
    EnterpriseId() {
      if (this.$store.getters.getUserInfo.enterprise) {
        return this.$store.getters.getUserInfo.enterprise.id;
      } else {
        return '';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/todoCenter/logo.vue